import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-xs text-gray-500 px-2 pb-2"
}

import { computed } from "vue";
import NotificationItem from "./NotificationItem.vue";
import { useStore } from "vuex";
import moment from "moment";
import { INotificationItem } from "../models/Notifications";
import { Container } from "inversify";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationsList',
  props: {
    notifications: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;
const deleteNotification = (message: INotificationItem) => {
  store.dispatch("deleteNotification", message);
};
const markAllNotificationsAsRead = async () => {
  await store.dispatch("markAllAsRead");
};

const clearAllNotifications = async () => {
  const containerId = store.getters.container.id;
  await store.dispatch("deleteAllNotifications", containerId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "flex flex-row gap-4 p-2" }, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-darkGray-1 place-self-end font-semibold" }, "Notifikationer", -1)),
      _createElementVNode("p", {
        class: "text-red-2 text-xs place-self-end cursor-pointer",
        onClick: clearAllNotifications
      }, " Rensa alla ")
    ]),
    _createElementVNode("div", _hoisted_1, [
      (props.notifications.filter((notification) => {
        return _ctx.notifications;
      
      // if (moment(notification.timestamp).diff(moment(), 'days') < -7) {
      //   return notification;
      // }
    }).length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.notifications.filter((notification) => {
      // if (moment(notification.timestamp).diff(moment(), 'days') < -7) {
        {
        return notification;
      }
    }), (notification) => {
              return (_openBlock(), _createElementBlock("li", {
                key: notification.id
              }, [
                _createVNode(NotificationItem, {
                  "max-message-length": "71",
                  notification: notification
                }, null, 8, ["notification"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, "Inga notifikationer"))
    ])
  ], 64))
}
}

})